import { useCallback, useEffect, useState } from "react";
import OrderCard from "../../../../components/common/orderCard";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { Card, Pagination, Rate, Spin, message } from "antd";
import TextArea from "../../../../components/common/textArea";
import Button from "../../../../components/common/button";
import { colors } from "../../../../share/constants/enums";
import { updateOrder } from "../../../../api/order";
import { LoadingOutlined } from "@ant-design/icons";
import { addReview } from "../../../../api/reviews";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrdersList } from "../../../../store/slices/orderSlice";

const Orders = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [render, setRender] = useState(false);
  const [comment, setComment] = useState("");
  const [pageSize, setPagesize] = useState(6);

  const [stars, setStars] = useState(0);
  const [selectedCard, setSelectedCard] = useState();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const orders = useSelector((state) => state?.order);
  const user = useSelector((state) => state?.user?.response);
  const orderValues = orders?.response;
  const text = useSelector((state) => state?.text?.value);
  const fetchData = useCallback(async () => {
    const payload = {
      orderStatus: ["NOT_REDEEMED"],
      itemPerPage: pageSize,
      currentPage: currentPage,
      text: text || null,
    };
    dispatch(fetchOrdersList(payload));
  }, [dispatch, currentPage, pageSize, text]);
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  useEffect(() => {
    fetchData();
  }, [render, currentPage, pageSize, fetchData]);

  const handleRatingChange = (value) => {
    setStars(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const reviewHandler = async () => {
    setLoader(true);
    const payload = {
      customerUserId: selectedCard?.userId?._id,
      businessId: selectedCard?.businessId?._id,
      orderId: selectedCard?._id,
      isBusiness: true,
      rating: stars,
      comments: [
        {
          commentUser: user?._id,
          commentText: comment,
        },
      ],
    };
    const updatePayload = {
      orderStatus: "COMPLETED",
    };
    if (!stars || !comment) {
      message.error("Please provide both a rating and a comment to continue!");
    } else {
      const res = await updateOrder(selectedCard?._id, updatePayload);
      if (res) {
        await addReview(payload);
        message.success("Review Sent!");
        setComment("");
        setStars(0);
        setRender(!render);
      }
    }
    setLoader(false);
  };
  const hideModal = () => {
    setIsModalOpen(false);
    setShowCard(false);
    setComment("");
    setStars(0);
  };

  const YesClickHandler = async () => {
    setLoader(true);

    const updatePayload = {
      orderStatus: "COMPLETED",
    };
    setIsModalOpen(false);
    const res = await updateOrder(selectedCard?.orderNumber, updatePayload);
    if (res) {
      setRender(!render);
      message.success("Order Redeemed!");
    }

    // setShowCard(true);
    setComment("");
    setStars(0);
    setLoader(false);
  };
  const showModal = (data) => {
    setIsModalOpen(true);
    setSelectedCard(data);
  };
  const handleTextChange = (e) => {
    setComment(e);
  };

  if (orders?.isLoading || loader) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spin indicator={<LoadingOutlined />} size="large" />
      </div>
    );
  }
  if (!orderValues?.totalItems && !orders?.isLoading) {
    return (
      <div className="flex justify-center opacity-50 mt-20">
        <h1 className="text-xl flex justify-center mr-2 mt-0.4">
          No Orders Yet
        </h1>
      </div>
    );
  }
  const showCardForOrder = (data) => {
    return (
      <Card className="bg-inputFieldGrey h-24 mx-3 mb-2">
        <div className="bg-white m-3">
          <TextArea
            className="h-10 max-h-10 "
            placeholder="Please leave a Review regarding this Order!"
            text={comment}
            handleTextChange={handleTextChange}
          />
        </div>
        <div className="flex justify-between">
          <div className="ml-3">
            <Rate
              className="text-[18px]"
              value={stars}
              allowHalf
              style={{
                color: colors.secondaryOrange,
              }}
              onChange={handleRatingChange}
            />
          </div>
          <Button
            className="w-15 !h-4 !rounded-md mr-3 !mb-1"
            color={colors.secondaryOrange}
            title="Post Review"
            loading={loader}
            onClick={reviewHandler}
          />
        </div>
      </Card>
    );
  };
  return (
    <div className={`relative ${isModalOpen ? "blur-sm " : ""}`}>
      <div className="">
        <div className="grid  md:grid-cols-2 2xl:grid-cols-3  gap-2 ">
          {orderValues?.items?.map((data, i) => (
            <div key={i}>
              <OrderCard data={data} openModal={() => showModal(data)} />
              {showCard &&
                selectedCard?._id === data?._id &&
                showCardForOrder(data)}
            </div>
          ))}
        </div>
        <div className="flex justify-center items-center pagination-container my-2">
          <Pagination
            current={currentPage}
            total={orderValues?.totalItems}
            pageSize={pageSize}
            pageSizeOptions={[4, 10, 20, 30]}
            onShowSizeChange={handleSizeChange}
            onChange={(e) => {
              handlePageChange(e);
            }}
          />
        </div>
      </div>
      {isModalOpen && (
        <DeleteMemberModal
          title="Redeemed"
          text="Do You Want to List this Order as Redeemed?"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
    </div>
  );
};
export default Orders;
